module.exports = __webpack_public_path__ + "static/media/default-orange-exclamation.cc7575aa.svg";